const appName = process.env.REACT_APP_NAME;

export default {
  appName: appName?.toUpperCase(),
  primaryColor: '#046A38',
  welcomeMessage: `From inventory tracking to sales analysis, our all-in-one solution empowers you to manage your shop with ease and efficiency`,
};
